interface IconProps {
  readonly icon: string;
}
export const Icon = ({ icon }: IconProps) => <i className={`fa-solid ${icon}`}></i>;
export const IconRaw = ({ icon }: IconProps) => <i className={icon}></i>;
